/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {ClrResponsiveNavigationService} from './clrResponsiveNavigationService';
/**
 * @param {?} existing
 * @return {?}
 */
export function clrResponsiveNavigationProvider(existing: ClrResponsiveNavigationService) {
    return existing || new ClrResponsiveNavigationService();
}
